module.exports = __webpack_public_path__ + "static/media/scarlet@2x.50c60b6a.png";